import React from 'react';
import './Footer.css';
import { NavLink, useLocation } from 'react-router-dom';

function Footer() {
  const location = useLocation();
  // Check if the current route is /terms or /policy
  const isSpecialRoute = location.pathname === '/terms' || location.pathname === '/policy';

  return (
    <footer
      className="footer"
      style={{ backgroundColor: isSpecialRoute ? 'rgba(0, 0, 0, 0.5)' : 'transparent' }}
    >
      <div className="footer-content">
        <div className="footer-links">
          <NavLink to="/terms" activeClassName="active-link">
            Terms &amp; Conditions
          </NavLink>
          <NavLink to="/policy" activeClassName="active-link">
            Privacy Policy
          </NavLink>
        </div>
        <div className="footer-social">
          <a
            href="https://twitter.com/airrived_ai"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/images/twitter.png" alt="Twitter" />
          </a>
          <a
            href="https://www.linkedin.com/company/airrived/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/images/linkedin.png" alt="LinkedIn" />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;